const COLORS = [
  "#ff595e",
  "#ffca3a",
  "#6a4c93",
  "#1982c4",
  "#8ac926",
  "#ff6b6b",
  "#ffd93d",
  "#6bcb77",
  "#4d96ff",
  "#ff9f1c",
  "#f72585",
  "#7209b7",
  "#3a86ff",
  "#fb5607",
  "#06d6a0",
];

const STYLE_ID = "sally-confetti-styles";

function injectStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes _confetti-fall {
      0%   { transform: translateY(0px) rotate(0deg) scale(1); opacity: 1; }
      85%  { opacity: 1; }
      100% { transform: translateY(105vh) rotate(800deg) scale(0.4); opacity: 0; }
    }
    @keyframes _confetti-sway {
      0%   { margin-left: 0px; }
      25%  { margin-left: 40px; }
      75%  { margin-left: -40px; }
      100% { margin-left: 15px; }
    }
    .sally-confetti-wrap {
      position: fixed;
      inset: 0;
      pointer-events: none;
      z-index: 9999;
      overflow: hidden;
    }
    .sally-confetti-p {
      position: absolute;
      top: -24px;
      animation:
        _confetti-fall var(--fd) ease-in var(--delay) forwards,
        _confetti-sway var(--sd) ease-in-out var(--delay) infinite;
    }
  `;
  document.head.appendChild(style);
}

export function fireConfetti(count = 130) {
  injectStyles();

  const wrap = document.createElement("div");
  wrap.className = "sally-confetti-wrap";
  document.body.appendChild(wrap);

  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const size = 7 + Math.random() * 11;
    const isCircle = Math.random() > 0.45;
    const isStrip = !isCircle && Math.random() > 0.5;

    el.className = "sally-confetti-p";
    el.style.cssText = [
      `left: ${Math.random() * 100}%`,
      `width: ${isStrip ? size * 0.3 : size}px`,
      `height: ${isStrip ? size * 1.8 : size}px`,
      `background: ${color}`,
      `border-radius: ${isCircle ? "50%" : "3px"}`,
      `--fd: ${2 + Math.random() * 2.2}s`,
      `--sd: ${0.8 + Math.random() * 1.2}s`,
      `--delay: ${Math.random() * 0.9}s`,
    ].join(";");

    wrap.appendChild(el);
  }

  setTimeout(() => wrap.remove(), 4500);
}
